import React, { useState, useEffect } from 'react';
import Chat from './screens/Chat';
import Devis from './screens/Devis';
import Chantiers from './screens/Chantiers';
import Profil, { Login, Signup, ForgotPassword, ResetPassword } from './screens/Profil';

const CHECKOUT_URL = 'https://compagnon-paiement.lemonsqueezy.com/checkout/buy/8a1ec5b4-1100-467d-b905-090ffce52506';
const JOURS_ESSAI = 15;

const NAV = [
  { id: 'chat', label: 'Chat', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M3 4h14v10a2 2 0 01-2 2H5a2 2 0 01-3-2V4z" stroke={active ? '#FFD700' : '#4a7abf'} strokeWidth="1.2"/>
      <path d="M6 8h8M6 11h5" stroke={active ? '#FFD700' : '#4a7abf'} strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  )},
  { id: 'devis', label: 'Devis', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="3" y="2" width="14" height="16" rx="2" stroke={active ? '#FFD700' : '#4a7abf'} strokeWidth="1.2"/>
      <path d="M7 7h6M7 10h6M7 13h4" stroke={active ? '#FFD700' : '#4a7abf'} strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  )},
  { id: 'chantiers', label: 'Chantiers', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2 17L10 3L18 17H2Z" stroke={active ? '#FFD700' : '#4a7abf'} strokeWidth="1.2" fill="none" strokeLinejoin="round"/>
      <path d="M10 9v4M10 15v1" stroke={active ? '#FFD700' : '#4a7abf'} strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  )},
  { id: 'profil', label: 'Profil', icon: (active) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="7" r="3" stroke={active ? '#FFD700' : '#4a7abf'} strokeWidth="1.2"/>
      <path d="M3 18c0-3.866 3.134-7 7-7s7 3.134 7 7" stroke={active ? '#FFD700' : '#4a7abf'} strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  )},
];

function PageBlocage({ artisan }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100dvh', background: '#0a0a0a', padding: '0 24px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>⚒️</div>
        <h2 style={{ color: '#e8eaf0', fontSize: 22, fontWeight: 700, margin: '0 0 12px' }}>Votre essai gratuit est terminé</h2>
        <p style={{ color: '#4a7abf', fontSize: 14, lineHeight: 1.7, margin: '0 0 8px' }}>Bonjour {artisan?.nom_entreprise || ''} !</p>
        <p style={{ color: '#4a7abf', fontSize: 13, lineHeight: 1.7, margin: '0 0 32px' }}>Vous avez profité de vos 15 jours d'essai gratuit. Pour continuer à utiliser Compagnon et générer vos devis en un instant, abonnez-vous à Compagnon Pro.</p>
        <div style={{ background: '#0d1117', border: '0.5px solid #1a2744', borderRadius: 16, padding: '20px', marginBottom: 24 }}>
          <p style={{ color: '#FFD700', fontSize: 28, fontWeight: 700, margin: '0 0 4px' }}>29,99€</p>
          <p style={{ color: '#4a7abf', fontSize: 13, margin: '0 0 16px' }}>par mois — sans engagement</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, textAlign: 'left' }}>
            {[
              '✅ Chat IA BTP illimité',
              '✅ Devis & factures en 1 minute',
              '✅ Onglet Chantiers — toutes les opportunités',
              '✅ Mises à jour incluses',
            ].map((f, i) => (
              <p key={i} style={{ color: '#c8d4e8', fontSize: 13, margin: 0 }}>{f}</p>
            ))}
          </div>
        </div>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" style={{ display: 'block', width: '100%', background: '#FFD700', color: '#0a0a0a', border: 'none', borderRadius: 20, padding: '14px 0', fontSize: 15, fontWeight: 700, textDecoration: 'none', marginBottom: 12, boxSizing: 'border-box' }}>
          S'abonner à Compagnon Pro
        </a>
        <p style={{ color: '#4a7abf', fontSize: 11, margin: 0 }}>Après paiement, revenez sur l'app et rafraîchissez la page pour accéder à votre compte.</p>
      </div>
    </div>
  );
}

function BanniereEssai({ joursRestants }) {
  if (joursRestants > 5) return null;
  return (
    <div style={{ background: joursRestants <= 2 ? '#1a0a0a' : '#2a1e00', borderBottom: `0.5px solid ${joursRestants <= 2 ? '#e05a5a' : '#FFD700'}`, padding: '8px 16px', textAlign: 'center', fontSize: 12, color: joursRestants <= 2 ? '#e05a5a' : '#FFD700', flexShrink: 0 }}>
      {joursRestants <= 0 ? '⚠️ Votre essai gratuit est terminé' : `⏳ Il vous reste ${joursRestants} jour${joursRestants > 1 ? 's' : ''} d'essai gratuit`}
    </div>
  );
}

export default function App() {
  const [screen, setScreen] = useState('chat');
  const [auth, setAuth] = useState('loading');
  const [artisan, setArtisan] = useState(null);
  const [devisPreRempli, setDevisPreRempli] = useState(null);

  const handleDevisDetecte = (devisData) => {
    setDevisPreRempli(devisData);
    setScreen('devis');
  };

  useEffect(() => {
    // Détecter si l'URL contient un token de réinitialisation
    const hash = window.location.hash;
    if (hash && hash.includes('type=recovery')) {
      setAuth('reset');
      return;
    }

    const token = localStorage.getItem('compagnon_token');
    const userId = localStorage.getItem('compagnon_user_id');
    const loginTime = localStorage.getItem('compagnon_login_time');
    const sessionValide = loginTime && (Date.now() - parseInt(loginTime)) < 7 * 24 * 60 * 60 * 1000;

    if (token && userId && sessionValide) {
      import('./services/api').then(({ authAPI }) => {
        authAPI.getProfil(userId)
          .then(data => { setArtisan(data); setAuth('app'); })
          .catch(() => { localStorage.clear(); setAuth('login'); });
      });
    } else {
      localStorage.clear();
      setAuth('login');
    }
  }, []);

  const calculerJoursRestants = () => {
    if (!artisan?.date_inscription) return JOURS_ESSAI;
    const debut = new Date(artisan.date_inscription);
    const maintenant = new Date();
    const diff = Math.floor((maintenant - debut) / (1000 * 60 * 60 * 24));
    return Math.max(0, JOURS_ESSAI - diff);
  };

  if (auth === 'loading') return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100dvh', background: '#0a0a0a' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 56, height: 56, background: '#FFD700', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 28 }}>⚒</div>
        <p style={{ color: '#4a7abf', fontSize: 13 }}>Chargement…</p>
      </div>
    </div>
  );

  if (auth === 'reset') return (
    <ResetPassword onSuccess={() => {
      window.location.hash = '';
      setAuth('login');
    }} />
  );

  if (auth === 'login') return (
    <Login
      onLogin={(a) => { setArtisan(a); setAuth('app'); }}
      onSignup={() => setAuth('signup')}
      onForgot={() => setAuth('forgot')}
    />
  );

  if (auth === 'signup') return <Signup onBack={() => setAuth('login')} />;
  if (auth === 'forgot') return <ForgotPassword onBack={() => setAuth('login')} />;

  const joursRestants = calculerJoursRestants();
  const essaiTermine = joursRestants <= 0 && !artisan?.abonne;
  if (essaiTermine) return <PageBlocage artisan={artisan} />;

  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      height: '100dvh', maxWidth: 480, margin: '0 auto',
      background: '#0a0a0a', position: 'relative', overflow: 'hidden',
      paddingTop: 'env(safe-area-inset-top)',
      paddingBottom: 'env(safe-area-inset-bottom)',
    }}>
      <BanniereEssai joursRestants={joursRestants} />
      <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        {screen === 'chat' && <Chat artisan={artisan} onDevisDetecte={handleDevisDetecte} />}
        {screen === 'devis' && <Devis artisan={artisan} devisPreRempli={devisPreRempli} onDevisGenere={() => setDevisPreRempli(null)} />}
        {screen === 'chantiers' && <Chantiers artisan={artisan} />}
        {screen === 'profil' && <Profil artisan={artisan} onLogout={() => { setAuth('login'); setArtisan(null); }} />}
      </div>
      <div style={{
        background: '#0d1117', borderTop: '0.5px solid #1a2744',
        display: 'flex', justifyContent: 'space-around',
        padding: '8px 0 10px', flexShrink: 0,
      }}>
        {NAV.map(n => (
          <button key={n.id} onClick={() => setScreen(n.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, padding: '4px 12px' }}>
            {n.icon(screen === n.id)}
            <span style={{ fontSize: 10, color: screen === n.id ? '#FFD700' : '#4a7abf', fontWeight: screen === n.id ? 600 : 400 }}>{n.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
